/**
 * Session Status Indicator
 * Shows session expiration time in the sidebar
 * Visual indicator for session health
 */

import { useSessionManager } from '@/hooks/use-session-manager';
import { useAuthStore } from '@/store/auth-store';
import { Clock, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function SessionStatus() {
  const { isAuthenticated } = useAuthStore();
  const { remainingTime, refreshToken } = useSessionManager();

  if (!isAuthenticated || !remainingTime) {
    return null;
  }

  const minutes = Math.floor(remainingTime / 1000 / 60);
  const isExpiringSoon = minutes < 15; // Less than 15 minutes
  const isCritical = minutes < 5; // Less than 5 minutes

  const statusColor = isCritical
    ? 'text-red-600'
    : isExpiringSoon
      ? 'text-yellow-600'
      : 'text-green-600';

  return (
    <div className="flex items-center justify-between gap-2 px-3 py-2 rounded-md bg-muted/50">
      <div className="flex items-center gap-2">
        <Clock className={`h-4 w-4 ${statusColor}`} />
        <div className="flex flex-col">
          <span className="text-xs font-medium">Session</span>
          <span className={`text-xs ${statusColor}`}>
            {minutes}m remaining
          </span>
        </div>
      </div>
      <Button
        variant="ghost"
        size="sm"
        className="h-7 w-7 p-0"
        onClick={() => refreshToken()}
        title="Refresh session"
      >
        <RefreshCw className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
